/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetDisabledClientNotifications200Response
 */
export interface GetDisabledClientNotifications200Response {
    /**
     * 
     */
    clientUUIDs?: Array<string>;
}

/**
 * Check if a given object implements the GetDisabledClientNotifications200Response interface.
 */
export function instanceOfGetDisabledClientNotifications200Response(value: object): value is GetDisabledClientNotifications200Response {
    return true;
}

export function GetDisabledClientNotifications200ResponseFromJSON(json: any): GetDisabledClientNotifications200Response {
    return GetDisabledClientNotifications200ResponseFromJSONTyped(json, false);
}

export function GetDisabledClientNotifications200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDisabledClientNotifications200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'clientUUIDs': json['clientUUIDs'] == null ? undefined : json['clientUUIDs'],
    };
}

export function GetDisabledClientNotifications200ResponseToJSON(json: any): GetDisabledClientNotifications200Response {
    return GetDisabledClientNotifications200ResponseToJSONTyped(json, false);
}

export function GetDisabledClientNotifications200ResponseToJSONTyped(value?: GetDisabledClientNotifications200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientUUIDs': value['clientUUIDs'],
    };
}

